import { createVanIconComponent } from "./van"

const BalanceOutlined = createVanIconComponent("balance-o")
export default BalanceOutlined
